"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureVueInternalTypes = exports.VueModel$Vue = void 0;
exports.VueModel$Vue = null;
function ensureVueInternalTypes(target, Vue) {
    // Exit early if Observer or Dep are already defined
    if (target.Observer || target.Dep) {
        return;
    }
    var observableData;
    if (Vue.observable) {
        observableData = Vue.observable({});
    }
    else {
        var component = new Vue({
            data: function () {
                return {};
            }
        });
        observableData = component.$data;
    }
    var observer = observableData.__ob__;
    var observerCtor = observer.constructor;
    var depCtor = observer.dep.constructor;
    target.Observer = observerCtor;
    target.Dep = depCtor;
}
exports.ensureVueInternalTypes = ensureVueInternalTypes;
